import {
    CLEAR_DATA,
    GET_ALL_TEMPLATES,
    GET_ALL_TEMPLATES_SUCCESS,
    GET_ALL_TEMPLATES_FAILED,
    SELECT_TEMPLATE,
    CREAT_BATCH_SCAN,
    CREAT_BATCH_SCAN_SUCCESS,
    CREAT_BATCH_SCAN_FAILED,
    UPLOAD_DOCUMENT,
    SUBSCRIBE_UPLOADING_DOCUMENT,
    UPLOAD_DOCUMENT_SUCCESS,
    UPLOAD_DOCUMENT_FAILED,
    GET_UPLOADING_DOCUMENT,
    GET_UPLOADING_DOCUMENT_SUCCESS,
    GET_UPLOADING_DOCUMENT_FAILED,
    OPEN_DOCUMENT_EDITOR,
    EDIT_DOCUMENT_IN_SESSION,
    EDIT_DOCUMENT_IN_SESSION_SUCCESS,
    EDIT_DOCUMENT_IN_SESSION_FAILED,
    DELETE_DOCUMENT_FROM_SESSION,
    DELETE_DOCUMENT_FROM_SESSION_SUCCESS,
    DELETE_DOCUMENT_FROM_SESSION_FAILED,
    EXECUTE_BATCH_SCAN,
    EXECUTE_BATCH_SCAN_SUCCESS,
    EXECUTE_BATCH_SCAN_FAILED,
    VIEW_PROCESSING_DOCUMENT
} from './constants';

type Action = { type: string, payload: {} | string };

export const clearData = (): Action => ({
    type: CLEAR_DATA,
    payload: {},
});

export const getAllTemplates = (): Action => ({
    type: GET_ALL_TEMPLATES,
    payload: {},
});

export const getAllTemplatesSuccess = (entities: Array): Action => ({
    type: GET_ALL_TEMPLATES_SUCCESS,
    payload: entities,
});

export const getAllTemplatesFailed = (error: string): Action => ({
    type: GET_ALL_TEMPLATES_FAILED,
    payload: error,
});

export const selectTemplate = (template): Action => ({
    type: SELECT_TEMPLATE,
    payload: template,
});

export const createBatchScan = (doc_type): Action => ({
    type: CREAT_BATCH_SCAN,
    payload: {doc_type},
});

export const createBatchScanSuccess = ({channel, session_id}): Action => ({
    type: CREAT_BATCH_SCAN_SUCCESS,
    payload: {channel, batchId: session_id},
});

export const createBatchScanFailed = (error: string): Action => ({
    type: CREAT_BATCH_SCAN_FAILED,
    payload: error,
});

export const uploadDocument = (document): Action => ({
    type: UPLOAD_DOCUMENT,
    payload: document,
});

export const subscribeUploadingDocument = (response): Action => ({
    type: SUBSCRIBE_UPLOADING_DOCUMENT,
    payload: response,
});

export const uploadDocumentSuccess = (response): Action => ({
    type: UPLOAD_DOCUMENT_SUCCESS,
    payload: response,
});

export const uploadDocumentFailed = (response): Action => ({
    type: UPLOAD_DOCUMENT_FAILED,
    payload: response,
});

export const getUploadingDocument = (mapId: string): Action => ({
    type: GET_UPLOADING_DOCUMENT,
    payload: mapId,
});

export const getUploadingDocumentSuccess = (response): Action => ({
    type: GET_UPLOADING_DOCUMENT_SUCCESS,
    payload: response,
});

export const getUploadingDocumentFailed = (response): Action => ({
    type: GET_UPLOADING_DOCUMENT_FAILED,
    payload: response,
});

export const openDocumentEditor = (mapId: string): Action => ({
    type: OPEN_DOCUMENT_EDITOR,
    payload: mapId,
});

export const editDocumentInSession = (document): Action => ({
    type: EDIT_DOCUMENT_IN_SESSION,
    payload: document,
});

export const editDocumentInSessionSuccess = (response): Action => ({
    type: EDIT_DOCUMENT_IN_SESSION_SUCCESS,
    payload: response,
});

export const editDocumentInSessionFailed = (error: string): Action => ({
    type: EDIT_DOCUMENT_IN_SESSION_FAILED,
    payload: error,
});

export const deleteDocumentFromSession = (mapId: string): Action => ({
    type: DELETE_DOCUMENT_FROM_SESSION,
    payload: mapId,
});

export const deleteDocumentFromSessionSuccess = (response): Action => ({
    type: DELETE_DOCUMENT_FROM_SESSION_SUCCESS,
    payload: response,
});

export const deleteDocumentFromSessionFailed = (error: string): Action => ({
    type: DELETE_DOCUMENT_FROM_SESSION_FAILED,
    payload: error,
});

export const executeBatchScan = (): Action => ({
    type: EXECUTE_BATCH_SCAN,
    payload: {},
});

export const executeBatchScanSuccess = (response): Action => ({
    type: EXECUTE_BATCH_SCAN_SUCCESS,
    payload: response,
});

export const executeBatchScanFailed = (error: string): Action => ({
    type: EXECUTE_BATCH_SCAN_FAILED,
    payload: error,
});

export const viewProcessingDocument = (index): Action => ({
    type: VIEW_PROCESSING_DOCUMENT,
    payload: index,
});
